
import XHeader from 'vux/src/components/x-header/index.vue'

import {fetch,promptMessage } from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
export default {
data(){
return{

}

},
components: {
XHeader
},
methods:{

},
mounted() {
getken(this.getUserId);
}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationtimestamp.vue